<div
  class="px-5 pt-5 pb-8 min-w-0 mx-auto flex items-center"
  [class.justify-between]="showCallMeta()"
  [class.justify-center]="!showCallMeta()"
>
  <div class="flex flex-col gap-2 flex-shrink-0" [class.hidden]="!showCallMeta()">
    <span class="text-white font-semibold text-xl"
      >Cuộc gọi {{ callType() === CALL_TYPE.AUDIO ? 'thoại' : 'video' }}</span
    >
    <span class="text-white font-medium text-sm">{{ callDuration() }}</span>
  </div>
  <div #actionBarContainer class="flex justify-center items-center gap-2 w-full">
    @if (callState() === CALL_STATE.ENDED) {
      <div class="flex items-center gap-10">
        <div class="flex flex-col items-center gap-2">
          <button
            nz-button
            nzType="default"
            class="w-14 h-14 bg-action-btn border-none flex items-center justify-center rounded-full shadow active:scale-95 transition"
            (click)="handleClose()"
          >
            <app-icon name="call/x-icon" [size]="32" svgClass="text-text-onsecondary" />
          </button>
          <span class="text-xs sm:text-sm font-normal text-white">Đóng</span>
        </div>
        @if (hasCurrentCall() && isInviter()) {
          <div class="flex flex-col items-center gap-2">
            <button
              nz-button
              nzType="default"
              class="w-14 h-14 !bg-call-accept border-none flex items-center justify-center rounded-full shadow active:scale-95 transition"
              (click)="reCall()"
            >
              <app-icon name="call/start-call-icon" [size]="32" svgClass="text-white" />
            </button>
            <span class="text-xs sm:text-sm font-normal text-white">Gọi lại</span>
          </div>
        }
      </div>
    } @else {
      <!-- Camera button -->
      @if (!isCameraPermissionGranted() || !hasCamDevice()) {
        <button
          nz-button
          nzType="default"
          class="w-14 h-14 !bg-[--color-border-error] border-none flex items-center justify-center rounded-full shadow active:scale-95 transition"
          [disabled]="isDisabledActionBar()"
          (click)="requestCamMicPermission('cam')"
        >
          <app-icon name="meeting/camera-off-icon" [size]="32" svgClass="text-white" />
        </button>
      } @else {
        <button
          nz-button
          nzType="default"
          class="w-14 h-14 bg-action-btn border-none flex items-center justify-center rounded-full shadow active:scale-95 transition"
          [class]="{ '!bg-white': !localCamState() }"
          [disabled]="isDisabledActionBar()"
          (click)="handleToggleCam()"
        >
          <app-icon
            [name]="localCamState() ? 'meeting/camera-on-icon' : 'meeting/camera-off-icon'"
            [size]="32"
            [svgClass]="
              localCamState() ? 'text-[--color-text-onsecondary]' : 'text-[--color-text-error]'
            "
          />
        </button>
      }

      <!-- Mute button -->
      @if (!isMicPermissionGranted() || !hasMicDevice()) {
        <button
          nz-button
          nzType="default"
          class="w-14 h-14 !bg-[--color-border-error] border-none flex items-center justify-center rounded-full shadow active:scale-95 transition"
          [disabled]="isDisabledActionBar()"
          (click)="requestCamMicPermission('mic')"
        >
          <app-icon name="meeting/mic-off-icon" [size]="32" svgClass="text-white" />
        </button>
      } @else {
        <button
          nz-button
          nzType="default"
          class="w-14 h-14 bg-action-btn border-none flex items-center justify-center rounded-full shadow active:scale-95 transition"
          [class]="{ '!bg-white': !localMicState() }"
          [disabled]="isDisabledActionBar()"
          (click)="handleToggleMic()"
        >
          <app-icon
            [name]="localMicState() ? 'meeting/mic-on-icon' : 'meeting/mic-off-icon'"
            [size]="32"
            [svgClass]="localMicState() ? 'text-text-onsecondary' : 'text-text-error'"
          />
        </button>
      }

      <!-- Screen share (hides 3rd) -->
      <button
        nz-button
        nzType="default"
        class="w-14 h-14 bg-action-btn border-none flex items-center justify-center rounded-full shadow active:scale-95 transition"
        [class.hidden]="visibleExtraButtons() <= 0"
        [class]="{ '!bg-white': isScreenSharing() }"
        (click)="handleToggleScreen()"
        [disabled]="isDisableShareScreen()"
      >
        <app-icon
          name="meeting/share-screen-icon"
          [size]="32"
          [svgClass]="isScreenSharing() ? 'text-text-primary' : 'text-white'"
        />
      </button>

      <!-- Emoji (hides 2nd) -->
      <button
        nz-button
        nzType="default"
        class="w-14 h-14 bg-action-btn border-none flex items-center justify-center rounded-full shadow active:scale-95 transition text-text-onbrand"
        [class.hidden]="visibleExtraButtons() <= 1"
        (click)="toggleUpdate()"
      >
        <app-icon
          name="meeting/emoji-icon"
          [size]="32"
          [svgClass]="'text-[--color-text-onsecondary]'"
        />
      </button>

      <!-- Invite more (hides 1st) -->
      <button
        nz-button
        nzType="default"
        class="w-14 h-14 bg-action-btn border-none flex items-center justify-center rounded-full shadow active:scale-95 transition"
        [class.hidden]="visibleExtraButtons() <= 2"
        (click)="toggleUpdate()"
      >
        <app-icon
          name="meeting/add-member-icon"
          [size]="32"
          [svgClass]="'text-[--color-text-onsecondary]'"
        />
      </button>

      <!-- Menu -->
      <div class="relative">
        <button
          nz-button
          nzType="default"
          (click)="showMenu.set(!showMenu())"
          class="w-14 h-14 bg-action-btn border-none flex items-center justify-center rounded-full shadow active:scale-95 transition"
        >
          <app-icon
            name="meeting/more-action"
            [size]="32"
            [svgClass]="'text-[--color-text-onsecondary]'"
          />
        </button>

        @if (showMenu()) {
          <!-- Backdrop to close -->
          <div class="fixed inset-0 z-40" (click)="showMenu.set(false)"></div>
          <!-- Menu -->
          <div class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-50">
            <ul
              class="!bg-call-menu !border-none !rounded-xl !p-2 !shadow-lg min-w-[200px] flex flex-col gap-1 m-0 list-none"
            >
              <li
                class="px-4 py-2 text-white hover:bg-menu-item-hover rounded-lg flex items-center gap-3 cursor-pointer"
                [class.hidden]="visibleExtraButtons() > 0"
                (click)="toggleUpdate(); showMenu.set(false)"
              >
                <app-icon name="meeting/share-screen-icon" [size]="20" svgClass="text-white" />
                <span class="font-medium text-sm">Chia sẻ màn hình</span>
              </li>
              <li
                class="px-4 py-2 text-white hover:bg-menu-item-hover rounded-lg flex items-center gap-3 cursor-pointer"
                [class.hidden]="visibleExtraButtons() > 1"
                (click)="toggleUpdate(); showMenu.set(false)"
              >
                <app-icon name="meeting/emoji-icon" [size]="20" svgClass="text-white" />
                <span class="font-medium text-sm">Cảm xúc</span>
              </li>
              <li
                class="px-4 py-2 text-white hover:bg-menu-item-hover rounded-lg flex items-center gap-3 cursor-pointer"
                [class.hidden]="visibleExtraButtons() > 2"
                (click)="toggleUpdate(); showMenu.set(false)"
              >
                <app-icon name="meeting/add-member-icon" [size]="20" svgClass="text-white" />
                <span class="font-medium text-sm">Thêm người</span>
              </li>
              <li
                class="px-4 py-2 text-white hover:bg-menu-item-hover rounded-lg flex items-center gap-3 cursor-pointer"
                (click)="toggleUpdate(); showMenu.set(false)"
              >
                <app-icon name="meeting/control-icon" [size]="20" svgClass="text-white" />
                <span class="font-medium text-sm">Cài đặt</span>
              </li>
            </ul>
          </div>
        }
      </div>

      <!-- End call -->
      <button
        nz-button
        nzType="primary"
        class="w-14 h-14 !bg-call-end border-none flex items-center justify-center rounded-full shadow active:scale-95 transition"
        (click)="handleEndCall()"
      >
        <app-icon name="meeting/end-call" [size]="32" />
      </button>
    }
  </div>
  <div class="flex items-center gap-1.5 flex-shrink-0" [class.hidden]="!showCallMeta()">
    <app-icon name="call/lock-circle" [size]="20" svgClass="text-white" />
    <span class="text-white text-sm font-normal">Cuộc gọi mã hoá đầu cuối</span>
  </div>
</div>
